// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2VYc1","footer":"ModalCreateQualiphyProcedure_footer__EOYJY","additionData":"ModalCreateQualiphyProcedure_additionData__3UOQl"};